import { router as createRouter } from 'dom-router';

export let r;

export function router(arg = { active: false }) {
  r = window.exlRouter = createRouter({
    active: false,
    css: {
      current: 'is-active',
      hidden: 'is-hidden',
    },
    stickyPos: false, // @todo remove when tech debt in app.js router has been removed
    stickySearchParams: true, // @todo remove when tech debt in app.js router has been removed
    stickyRoute: false, // @todo remove when tech debt in app.js router has been removed
    logging: true,
    stop: true,
    ...arg,
  });

  return r;
}
